import { siteService } from '_services';
import { session } from '_helpers';
import { ACTIONS_SITE } from '_constants/site.constants';
import alertActions from './alert.actions';

export const receiveSites = (sites) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < sites.length; i++) {
    byIdObjectToDispatch[sites[i].siteID] = sites[i];
  }

  return {
    type: ACTIONS_SITE.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteSite = (siteId) => ({
  type: ACTIONS_SITE.DELETE,
  byId: { [siteId]: null }
});

const getSites = () => async (dispatch) => {
  try {
    const resp = await siteService.getAll();
    if (resp?.length) {
      dispatch(receiveSites(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving sites.'));
  }
  return null;
};

const getSite = (siteID) => async (dispatch) => {
  try {
    const resp = await siteService.getById(siteID);
    if (resp?.name) {
      dispatch(receiveSites([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving site #${siteID}.`));
  }
  return null;
};

const addSite = (site) => async (dispatch) => {
  try {
    const resp = await siteService.create(site);
    if (resp?.siteID) {
      dispatch(receiveSites([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const updSite = (site) => async (dispatch) => {
  try {
    const resp = await siteService.update(site);
    if (resp?.siteID) {
      dispatch(receiveSites([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delSite = (siteID) => async (dispatch) => {
  try {
    const resp = await siteService.delete(siteID);
    if (resp?.siteID) {
      dispatch(deleteSite(resp.siteID));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing site #${siteID}.`));
  }
  return null;
};

const invalidateSites = () => async (dispatch) => {
  await dispatch({
    type: ACTIONS_SITE.INVALIDATE,
  });
};

const siteActions = {
  getSites,
  getSite,
  addSite,
  updSite,
  delSite,
  invalidateSites
};

export default siteActions;
